export default __webpack_public_path__ + "static/media/white_logo.79aec97e.jpeg";